
import barba from '@barba/core';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText);


(function ($) {
  "use strict";

  $('.link-email').html('info@wedentify.nl').attr('href','mailto:info@wedentify.nl');

  const navigation = document.querySelector(".site-navigation");
  const hamburgerButton = document.querySelector(".site-nav-btn");
  const scrollDown = document.querySelector(".scroll-down");

  setTimeout(() => {
    navigation.toggleAttribute("is-loading", false);
  }, 300);
  document.onscroll = (e) => {
    navigation.setAttribute("is-scrolling", window.scrollY > 0);
    scrollDown.classList.toggle("is-visible", window.scrollY < 300);
  };

  hamburgerButton.onpointerdown = (e) => {
    const opened = hamburgerButton.getAttribute("aria-expanded") == "true";
    hamburgerButton.setAttribute("aria-expanded", !opened);
    navigation.setAttribute("aria-expanded", !opened);
    document.body.setAttribute("menu-expanded", !opened);
  };

  // const el = document.querySelector(".post-share")
  // const observer = new IntersectionObserver( 
  //   ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
  //   { threshold: [1] }
  // );

  // observer.observe(el);

  const modalButtons = document.querySelectorAll('.btn[data-modal-target]')
  modalButtons.forEach(btn => {
    btn.onclick = e => {
        e.preventDefault()
        const modal = document.querySelector(`#${btn.getAttribute('data-modal-target')}`)

        const open = () => {
            modal.toggleAttribute('open', true)
            document.body.setAttribute('no-scroll', true)
        }
        const close = (e) => {
            if (e) e.preventDefault()
            modal.toggleAttribute('open', false)
            document.body.setAttribute('no-scroll', false)
        }

        if (modal) {
            open()
            let backdrop;
            let modalCross;
            if (backdrop = modal.querySelector('.modal-backdrop')) {
                backdrop.onclick = close
            }
            if (modalCross = modal.querySelector('.modal-cross')) {
                modalCross.onclick = close
            }
        }
    }
  })

})(jQuery);



// const scrollers = document.querySelectorAll(
//   ".c-reviews-animated > .c-reviews-column",
// );
// // If a user hasn't opted in for recuded motion, then we add the animation
// if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
//   addAnimation();
// }

// function addAnimation() {
//   scrollers.forEach((scroller) => {
//     // add data-animated="true" to every `.wp-block-columns` on the page
//     scroller.setAttribute("data-animated", true);

//     // Make an array from the elements within `c-review-grid`
//     const scrollerInner = scroller.querySelector(".c-reviews-grid");
//     const scrollerContent = Array.from(scrollerInner.children);

//     // For each item in the array, clone it
//     // add aria-hidden to it
//     // add it into the `.scroller-inner`
//     scrollerContent.forEach((item) => {
//       const duplicatedItem = item.cloneNode(true);
//       duplicatedItem.setAttribute("aria-hidden", true);
//       scrollerInner.appendChild(duplicatedItem);
//     });
//   });
// }


// barba.init({
//   debug: true,
//   transitions: [{
//     sync: true,
//     name: 'default',
//     leave: (data) => {
//       return gsap.to(data.current.container,{
//         opacity: 0,          
//     });
//   },
//   beforeEnter: (data) => {
//     window.scrollTo(0, 0);
//     console.log('scrolltop');
//   },
//   enter: (data) => {
//     return  gsap.to(data.current.container,{
//           opacity: 0,          
//       });
//     },
//   }],
// });

if ($(".werken-met-ons").length > 0) {
  
  werken_voor_animation();

  function werken_voor_animation() {
    var tl = gsap.timeline();

    const slider = $(".werken-met-ons ul");
    const slides = slider.find("li");
    const number = window.innerWidth < 1024 ? 3 : 5; // (window.innerWidth > 1280) ? 7 :
    const staggerTime = 0.2;
    const dur = number * staggerTime;

    let currentSlide = 0;

    showMerken();

    function showMerken() {
      slider.empty();

      for (var i = 0; i < number; i++) {
        slider.append(slides[currentSlide]);
        currentSlide = ++currentSlide % slides.length;
      }
    
      const tl = gsap.timeline({ onComplete: showMerken });

      tl.to(slider.children(), {
        duration: dur,
        opacity: 1,
        stagger: staggerTime,
      });
      tl.to(
        slider.children(),
        { duration: dur, opacity: 0, stagger: staggerTime },
        "+=2",
      );
    }

    return tl;
  }
}

// Post card animation
const postCards = document.querySelectorAll(".post-card");
gsap.set(postCards, { opacity: 0 });

function setupPostCard(postCardsToAnimate) {

  postCardsToAnimate.forEach(postCard => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: postCard,
        start: 'top 80%',
      },
    });

    tl.fromTo(postCard, {
      y: 100,
      opacity: 0,
    }, {
      opacity: 1,
      y: 0,
      duration: 1.5,
    });

    tl.to(postCard.querySelector("img"), {
      scale: 1,
      duration: 1,
      boxShadow: "0 0 8rem rgba(12, 28, 36, 0.5)"
    }, "<");
  });
}

setTimeout(function() {
  setupPostCard(document.querySelectorAll(".post-card"));
}, 1000);

// Set gsap variables to new posts
function handleNewPosts(newPostsHtml) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = newPostsHtml;
  const newPosts = tempDiv.querySelectorAll('.post-card');
  document.querySelector('.post-grid').append(...newPosts);
  setupPostCard(newPosts);
}

// Load new posts
jQuery(function($) {
  let canBeLoaded = true;
  const bottomOffset = 3000;
  const url = window.location.origin + "/wp-admin/admin-ajax.php";
  const posttype = loadmore_params.current_post_type;

  if ($('.c-cases').length) {
    canBeLoaded = false;
  }

  $(window).scroll(function() {
    if ($(document).scrollTop() > ($(document).height() - bottomOffset) && canBeLoaded) {
      $.ajax({
        url: url,
        type: 'POST',
        data: {
          'action': 'load_more_posts',
          'query': posttype,
          'page': loadmore_params.current_page
        },
        beforeSend: function(xhr) {
          canBeLoaded = false;
        },
        success: function(response) {
          if (response) {
            handleNewPosts(response); 
            canBeLoaded = true;
            loadmore_params.current_page++;
          }
        }
      });
    }
  });
});

// // GSAP animations
// const pageTitle = document.querySelectorAll(".page-title");
// const pageIntro = document.querySelector(".page-intro");
// const uspTitle = document.querySelector(".c-usps > h2");
// const uspCards = document.querySelectorAll(".c-usps-card");
// const title = document.querySelectorAll("h2");

// function textSplit(element) {
//   if(element.anim) {
//     element.anim.progress(1).kill();
//     if (element.split) {
//       element.split.revert();
//     }
//   }

//   element.split = new SplitText(element, { 
//     type: "lines,words,chars",
//     linesClass: "split-line"
//   });

//   element.anim = gsap.from(element.split.chars, {
//     duration: 0.6, 
//     ease: "circ.out", 
//     y: 180, 
//     stagger: 0.02,
//     opacity: 0,
//     onStart: () => {
//       gsap.set(element, { opacity: 1 });
//     }
//   });
// }

// function setupSplits() {
//   window.onload = function () {
//     pageTitle.forEach(title => {
//       if(title.anim) {
//         title.anim.progress(1).kill();
//         title.split.revert();
//       }
  
//       title.split = new SplitText(title, { 
//         type: "lines,words,chars",
//         linesClass: "split-line"
//       });
  
//       title.anim = gsap.from(title.split.chars, {
//         duration: 0.6, 
//         ease: "circ.out", 
//         y: 180, 
//         stagger: 0.02,
//         opacity: 1,
//         onStart: () => {
//           gsap.set(title, { opacity: 1 });
//         }
//       });
//     });
//   }
// }

// function setupFade() {
//   gsap.fromTo(pageIntro,
//     { 
//       opacity: 0 
//     },
//     {
//         duration: 1.5,
//         opacity: 1,
//         ease: 'linear'
//     }
//   );
// }

// function setupUsp() {
//   const tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: title,
//       start: 'top center',
//       markers: true,
//     },
//   });

//   textSplit(uspTitle);

//   tl.add(uspTitle.anim)
//     .fromTo(uspCards, 
//       {
//         opacity: 0
//       },
//       {
//         opacity: 1,
//         duration: 1,
//         ease: 'linear',
//         stagger: 0.3,
//         delay: 0
//       }
//     );
// }

// function timeLineLandingPage() {
//   const tl = gsap.timeline();

//   tl.add(setupSplits, 0);
//   tl.add(setupFade, "+=1.3");

//   setupUsp();

//   return tl;
// }

// timeLineLandingPage();